import { Box, Button, Flex, useToast } from '@chakra-ui/react';
import { useCallback, useEffect } from 'react';

import CustomForm from '../../common/CustomForm/CustomForm';
import CustomInput from '../../common/CustomInput/CustomInput';
import { useUserContext } from '../../core/context/user.context';
import { isEmpty, isValidEmail, isValidPassword } from '../../core/helpers';
import useFetch from '../../core/hooks/useFetch';
import { useFormInput } from '../../core/hooks/useFormInput';

const BASE_URL = `${process.env.REACT_APP_API_URL}`;

function EmailForm() {
  const toast = useToast();
  const { user } = useUserContext();
  const newEmail = useFormInput('', (value) => !isEmpty(value) && isValidEmail(value));
  const password = useFormInput('', (value) => isValidPassword(value));
  const { result, doFetch, loading, error } = useFetch(`${BASE_URL}/user/request-email-change`);

  const handleSubmit = useCallback(() => {
    doFetch({
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${user.token}`,
      },
      body: JSON.stringify({
        email: newEmail.value,
        password: password.value,
        source: 'CMS',
      }),
    });
  }, [doFetch, user.token, newEmail, password]);

  useEffect(() => {
    if (result?.status !== 'success') return;
    toast({
      title: result.message,
      position: 'top',
      status: 'success',
      duration: 2000,
      isClosable: true,
    });
    newEmail.setValue('');
    password.setValue('');
  }, [result]);

  useEffect(() => {
    if (!error) return;
    toast({
      title: error.message,
      position: 'top',
      status: 'error',
      duration: 2000,
      isClosable: true,
    });
  }, [error]);

  return (
    <CustomForm inputs={[newEmail, password]} onSubmit={handleSubmit}>
      <Box bg="white" p={5} borderRadius={6} boxShadow="lg">
        <h1 className="h3" style={{ marginBottom: '20px' }}>
          Change Email
        </h1>
        <Flex justifyContent="flex-end" mb={5}>
          <Button
            isLoading={loading}
            isDisabled={loading}
            loadingText="Submitting"
            colorScheme="messenger"
            type="submit"
          >
            Save
          </Button>
        </Flex>
        <CustomInput
          id="new-email"
          type="text"
          name="new-email"
          placeholder="Enter new email address"
          label="New email address"
          input={newEmail}
          emptyMessage="Please fill in a new email address"
          invalidMessage="Please fill in a valid email address"
          autoComplete="off"
        />
        <CustomInput
          id="new-email-password"
          type="password"
          name="password"
          placeholder="Your password"
          label="Your password"
          input={password}
          emptyMessage="Please fill in your password"
          invalidMessage="Please fill in a valid password, minimum eight characters, one uppercase letter, one lowercase letter, one digit and one special character."
          autoComplete="off"
        />
      </Box>
    </CustomForm>
  );
}

export default EmailForm;
